import data from './attrs/data'
import methods from './attrs/methods'
import mounted from './attrs/mounted'
import ChangeProfilePicture from '@/components/Account/components/ChangeProfilePicture/Index'
import DeleteAccount from '@/components/Account/components/DeleteAccount/Index'

import { VueEditor } from  'vue2-editor'

export default {
    name: 'ContractorRegister',
    data,
    methods,
    mounted,
    components: {
        ChangeProfilePicture,
        DeleteAccount,
        VueEditor
    }
}
